import React, { useState } from 'react';
import { IconArrowRight } from '@tabler/icons-react';
const inputClasses = 'bg-white rounded-lg border border-white/20 px-4 py-3 text-navy w-full font-body focus:outline-none focus:border-accent-teal placeholder-[#9CA3AF]';
const inputStyle = {
  borderRadius: '8px'
};
const focusStyle = `
  .cta-input:focus {
    border-color: #69ddff;
    box-shadow: 0 0 0 3px rgba(105,221,255,0.15);
  }
`;
export function CtaSection() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    citta: '',
    appartamenti: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section id="waitlist-form" className="relative py-20 md:py-24 px-5 md:px-10 w-full overflow-hidden" style={{
    background: '#002CA5'
  }} data-id="element-30">
      <style data-id="element-31">{`${focusStyle}`}</style>
      {/* Pink glow — top right */}
      <div className="absolute pointer-events-none" style={{
      width: '400px',
      height: '400px',
      top: '-100px',
      right: '-100px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(255,64,129,0.08) 0%, transparent 70%)'
    }} data-id="element-32" />

      <style data-id="element-33">{`{focusStyle}`}</style>
      <div className="relative max-w-3xl mx-auto text-center" data-id="element-34">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-white" data-id="element-35">
          Meno telefonate. Meno stress. Meno costi.
        </h2>

        <p className="text-white/80 text-lg mt-4 font-body" data-id="element-36">
          CleanAI sta arrivando. Lascia i tuoi dati e ti avvisiamo appena siamo
          attivi nella tua zona.
        </p>

        <div className="mt-10 max-w-xl mx-auto" data-id="element-37">
          {isSubmitted ? <div className="bg-white/10 border border-accent-teal/50 rounded-lg p-8 text-center" data-id="element-38">
              <div className="text-4xl mb-4" data-id="element-39">🎉</div>
              <h3 className="font-heading font-bold text-2xl text-white mb-2" data-id="element-40">
                Grazie!
              </h3>
              <p className="text-white/80 font-body" data-id="element-41">
                Ti abbiamo aggiunto alla waitlist. Ti contatteremo presto con le
                prossime novità.
              </p>
            </div> : <form onSubmit={handleSubmit} className="text-left" data-id="element-42">
              {/* Row 1: Nome + Email */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-43">
                <div data-id="element-44">
                  <label htmlFor="nome" className="sr-only" data-id="element-45">
                    Nome
                  </label>
                  <input type="text" id="nome" name="nome" required placeholder="Il tuo nome" value={formData.nome} onChange={handleChange} className={`${inputClasses} cta-input`} style={inputStyle} data-id="element-46" />
                </div>
                <div data-id="element-47">
                  <label htmlFor="email" className="sr-only" data-id="element-48">
                    Email
                  </label>
                  <input type="email" id="email" name="email" required placeholder="La tua email" value={formData.email} onChange={handleChange} className={`${inputClasses} cta-input`} style={inputStyle} data-id="element-49" />
                </div>
              </div>

              {/* Row 2: Città + Appartamenti */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" data-id="element-50">
                <div data-id="element-51">
                  <label htmlFor="citta" className="sr-only" data-id="element-52">
                    Città
                  </label>
                  <input type="text" id="citta" name="citta" required placeholder="La tua città" value={formData.citta} onChange={handleChange} className={`${inputClasses} cta-input`} style={inputStyle} data-id="element-53" />
                </div>
                <div data-id="element-54">
                  <label htmlFor="appartamenti" className="sr-only" data-id="element-55">
                    Quanti appartamenti gestisci?
                  </label>
                  <select id="appartamenti" name="appartamenti" required value={formData.appartamenti} onChange={handleChange} className={`${inputClasses} cta-input ${formData.appartamenti === '' ? 'text-[#9CA3AF]' : 'text-navy'}`} style={inputStyle} data-id="element-56">
                    <option value="" disabled data-id="element-57">
                      Quanti appartamenti gestisci?
                    </option>
                    <option value="1-3" className="text-navy" data-id="element-58">
                      1–3
                    </option>
                    <option value="4-10" className="text-navy" data-id="element-59">
                      4–10
                    </option>
                    <option value="11-20" className="text-navy" data-id="element-60">
                      11–20
                    </option>
                    <option value="piu-di-20" className="text-navy" data-id="element-61">
                      Più di 20
                    </option>
                  </select>
                </div>
              </div>

              {/* Row 3: Submit — PINK CTA */}
              <button type="submit" className="mt-6 w-full rounded-full py-4 uppercase tracking-wide hover:opacity-90 transition-opacity text-[14px] font-[500]" style={{
            backgroundColor: '#69ddff',
            color: '#000b29'
          }} data-id="element-62">
                Entra nella waitlist
                <IconArrowRight size={16} stroke={2} className="inline ml-1.5" data-id="element-63" />
              </button>

              <p className="mt-3 text-center font-body" style={{
            fontSize: '13px',
            color: 'rgba(255,255,255,0.7)'
          }} data-id="element-64">
                Nessun costo, nessun impegno. Ti scriviamo solo quando è il
                momento.
              </p>
            </form>}
        </div>
      </div>
    </section>;
}